<template>
  <div id="success">
    <page-header>
      用户协议
    </page-header>
    <div class="detail" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "success",
  data() {
    return {
      content: ''
    };
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    getInfo () {
      this.axios.get('/xxgf-api/dict?configCode=ZDSZ-YHXY')
        .then(({data}) => {
          if (data.code === 200) {
            this.content = data.data.context;
          }
        })
    }
  }
};
</script>
<style lang="scss">
#success {
  background:#fff;
  padding: 124px 30px 30px;
}
</style>
